import React, {useEffect} from 'react';
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import MindsetsJsSDK, {SuccessMessageAction, ResponseContent, ReloadListAction} from "mindsets-js-sdk";
import {useSearchParams} from "react-router-dom";

function Row({item, row_number, practices_present}) {
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const practice_skills = useSelector(state => state.practice_skills);

    useEffect(() => {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

        return () => {
            tooltipList.map(tooltipTriggerEl => tooltipTriggerEl.dispose());
        }
    });

    function renderPractice(practice) {
        const scores = [];
        if (Array.isArray(item.response_points) && item.response_points.length) {
            item.response_points.filter(rp => rp.practice_id === practice.id).map(rp => {
                if (rp.points !== null) {
                    const practice_skill = practice_skills.find(practice_skill => practice_skill.id === rp.practice_skill_id);
                    if (practice_skill) {
                        scores.push(
                            <div key={rp.id + '-n-' + practice_skill.id}>
                                <span>{practice_skill.code}:&nbsp;</span>
                                <span className='badge text-bg-primary'>{rp.points}</span>
                            </div>
                        );
                    }
                }
            });
        }
        if (Array.isArray(item.response_auto_points) && item.response_auto_points.length) {
            item.response_auto_points.filter(rap => rap.practice_id === practice.id).map(rap => {
                if (rap.ai_points !== null) {
                    const practice_skill = practice_skills.find(practice_skill => practice_skill.id === rap.practice_skill_id);
                    if (practice_skill) {
                        if (rap.reasoning) {
                            scores.push(
                                <div key={rap.id + '-a-' + practice_skill.id}>
                                    <span>{practice_skill.code}:&nbsp;</span>
                                    <span
                                        className='badge text-bg-info'
                                        data-bs-toggle="tooltip"
                                        data-bs-title={rap.reasoning}
                                    >{rap.ai_points}</span>
                                </div>
                            );
                        } else {
                            scores.push(
                                <div key={rap.id + '-a-' + practice_skill.id}>
                                    <span>{practice_skill.code}:&nbsp;</span>
                                    <span className='badge text-bg-info'>{rap.ai_points}</span>
                                </div>
                            );
                        }
                    }
                }
                if (rap.attempt_points !== null) {
                    const practice_skill = practice_skills.find(practice_skill => practice_skill.id === rap.practice_skill_id);
                    if (practice_skill) {
                        scores.push(
                            <div key={rap.id + '-at-' + practice_skill.id}>
                                <span>{practice_skill.code}:&nbsp;</span>
                                <span className='badge text-bg-warning'>{rap.attempt_points}</span>
                            </div>
                        );
                    }
                }
                if (rap.ra_points !== null) {
                    const practice_skill = practice_skills.find(practice_skill => practice_skill.id === rap.practice_skill_id);
                    if (practice_skill) {
                        scores.push(
                            <div key={rap.id + '-r-' + practice_skill.id}>
                                <span>{practice_skill.code}:&nbsp;</span>
                                <span className='badge text-bg-secondary'>{rap.ra_points}</span>
                            </div>
                        );
                    }
                }
            });
        }

        // if (Array.isArray(item.response_points) && item.response_points.length) {
        //     item.response_points.map(rp => {
        //         if (rp.practice_skill_id === practice_skill.id && rp.points !== null) {
        //             scores.push(
        //                 <div key={rp.id + '-n-' + practice_skill.id}>
        //                     <span className='badge text-bg-primary'>{rp.points}</span>
        //                 </div>
        //             );
        //         }
        //     });
        // }
        // if (Array.isArray(item.response_auto_points) && item.response_auto_points.length) {
        //     item.response_auto_points.map(rap => {
        //         if (rap.practice_skill_id === practice_skill.id && rap.ai_points !== null) {
        //             if (rap.reasoning) {
        //                 scores.push(
        //                     <div key={rap.id + '-a-' + practice_skill.id}>
        //                         <span
        //                             className='badge text-bg-info'
        //                             data-bs-toggle="tooltip"
        //                             data-bs-title={rap.reasoning}
        //                         >{rap.ai_points}</span>
        //                     </div>
        //                 );
        //             } else {
        //                 scores.push(
        //                     <div key={rap.id + '-a-' + practice_skill.id}>
        //                         <span className='badge text-bg-info'>{rap.ai_points}</span>
        //                     </div>
        //                 );
        //             }
        //         }
        //         if (rap.practice_skill_id === practice_skill.id && rap.ra_points !== null) {
        //             scores.push(
        //                 <div key={rap.id + '-r-' + practice_skill.id}>
        //                     <span className='badge text-bg-secondary'>{rap.ra_points}</span>
        //                 </div>
        //             );
        //         }
        //     });
        // }

        return <td key={practice.id}>{scores}</td>;
    }

    const date = new Date(item.created_at * 1000);
    date.setUTCHours(0, 0, 0, 0);

    return (
        <tr key={item.id}>
            <td>{row_number}</td>
            <td style={{whiteSpace: 'nowrap'}}>
                <div>{item.id}</div>
                <div>{date.toISOString().substring(0, 10)}</div>
            </td>
            <td>
                <div style={{whiteSpace: 'nowrap'}}>
                    <div className='d-flex flex-gap-5 justify-content-between'>
                        <div>{item.stream.user.fname + ' ' + item.stream.user.lname}</div>
                        <button className='small' onClick={() => {
                            const searchParams = new URLSearchParams;
                            searchParams.set('column~0', 'user_id');
                            searchParams.set('expression~0', 'eq');
                            searchParams.set('value~0', item.stream.user.id);
                            setSearchParams(searchParams);
                            dispatch(ReloadListAction('action_logs'));
                        }} title='Show all responses of this user'>
                            <i className='fas fa-filter'/>
                        </button>
                    </div>
                    <div>{item.stream.user.email}</div>
                    <div>ID {item.stream.user.id}</div>
                </div>
            </td>
            <td>
                <div className='badge text-bg-secondary'>{item.question.answer_type}</div>
                <div dangerouslySetInnerHTML={{__html: 'Q' + item.question.number + ' ' + item.question.title}}/>
                <div>
                    <span className='badge text-bg-secondary'>{item.lesson.challenge_version.challenge_code.code}</span>
                    <span>&nbsp;</span>
                    <span>{item.lesson.challenge_version.name}(v{item.lesson.challenge_version.version})</span>
                    <span>&nbsp;</span>
                    <span className='badge text-bg-secondary'>{item.lesson.code.toUpperCase()}</span>
                    <span>&nbsp;</span>
                    <button className='small' onClick={() => {
                        const searchParams = new URLSearchParams;
                        searchParams.set('column~0', 'user_id');
                        searchParams.set('expression~0', 'eq');
                        searchParams.set('value~0', item.stream.user.id);
                        searchParams.set('column~1', 'lesson_id');
                        searchParams.set('expression~1', 'eq');
                        searchParams.set('value~1', item.lesson.id);
                        setSearchParams(searchParams);
                        dispatch(ReloadListAction('action_logs'));
                    }} title='Show all responses of this user for this Class'>
                        <i className='fas fa-filter'/>
                    </button>
                </div>
            </td>
            <td style={{wordBreak: 'break-word', color: !item.is_active ? 'lightgray' : ''}}>
                <ResponseContent
                    question={item.question}
                    response={item.data.answer}
                    response_id={item.id}/>
            </td>
            {practices_present.map(renderPractice)}
            <td>
                <button onClick={() => {
                    MindsetsJsSDK().API.post(`responses/${item.id}/schedule`)
                        .then(() => dispatch(SuccessMessageAction('Response has been scheduled for auto-grading')));
                }}>Grade
                </button>
            </td>
        </tr>
    );
}

Row.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.number.isRequired,
        stream: PropTypes.shape({
            user: PropTypes.shape({
                id: PropTypes.number.isRequired,
                email: PropTypes.string.isRequired,
                fname: PropTypes.string.isRequired,
                lname: PropTypes.string,
            }).isRequired,
        }).isRequired,
        question: PropTypes.shape({
            number: PropTypes.string.isRequired,
            answer_type: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            code: PropTypes.string.isRequired,
        }).isRequired,
        response_points: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number.isRequired,
            practice_id: PropTypes.number.isRequired,
            practice_skill_id: PropTypes.number.isRequired,
            points: PropTypes.number,
        })),
        response_auto_points: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number.isRequired,
            practice_id: PropTypes.number.isRequired,
            practice_skill_id: PropTypes.number.isRequired,
            ai_points: PropTypes.number,
            ra_points: PropTypes.number,
            attempt_points: PropTypes.number,
            reasoning: PropTypes.string,
        })),
        created_at: PropTypes.number.isRequired,
        is_active: PropTypes.bool,
        lesson: PropTypes.shape({
            id: PropTypes.string.isRequired,
            code: PropTypes.string.isRequired,
            challenge_version: PropTypes.shape({
                version: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
                challenge_code: PropTypes.shape({
                    code: PropTypes.string.isRequired,
                }).isRequired,
            }).isRequired,
        }).isRequired,
    }).isRequired,
    practices_present: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
    })).isRequired,
    row_number: PropTypes.number.isRequired,
};

export default Row;
